// ============================================================================
// src/components/BenchmarkPanel/DistributionChart.utils.ts
// PV-1052 · PR-G — Pure helpers extracted from DistributionChart.tsx so
// react-refresh stays happy (only-export-components rule).
// ============================================================================

/** Decide the deal marker tone : positive (below median), alert (above 5%), neutral otherwise. */
export function dealMarkerTone(deal: number, central: number): 'positive' | 'alert' | 'neutral' {
  if (deal < central) return 'positive';
  if (deal > central * 1.05) return 'alert';
  return 'neutral';
}
